// AcceptableUsePolicy.js
'use client';
'use strict';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';
import AcceptableUsePolicy from '../component/AcceptableUsePolicy.jsx';

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
  };
};

export default connect(null, mapDispatchToProps)(AcceptableUsePolicy);
